export default __webpack_public_path__ + "static/media/numpy.5bdfa40b.svg";